<template>
    <h3>Contenido</h3>
</template>
<script>
    export default{
        name: "BlogContenido",
    }
</script>
